import { graphql } from "~/gql";

export const LOGOUT = graphql(/* GraphQL */ `
  mutation logout {
    logout {
      success
    }
  }
`);
